// src/modules/app-views/_apps/appmulti/orders/service.js
// *******************************************************************************
// HELPER FUNCTIONS FOR ORDERS MODULE
// *******************************************************************************

// *******************************************************************************
// STATUS LIST
// *******************************************************************************
function getStatuses() {
  return [
    'waiting_for_payment',
    'overdue',
    'waiting_for_voucher',
    'done',
    'cancelled',
    'cancelled_by_customer',
  ];
}

// *******************************************************************************
// STATUS COLOR
// *******************************************************************************
function getStatusColor(status) {
  switch (status) {
    case 'waiting_for_payment':
      return 'orange';
    case 'overdue':
    case 'late_payment':
      return 'red';
    case 'waiting_for_voucher':
    case 'paid':
    case 'received':
      return 'purple';
    case 'done':
      return 'green';
    case 'cancelled':
    case 'cancelled_by_customer':
      return 'default';
    default:
      return 'geekblue';
  }
}

// *******************************************************************************
// DISPLAY STATUS (prefer backend __statusView, fall back to stored status)
// *******************************************************************************
function getDisplayStatus(record) {
  return record?.__statusView || record?.status;
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
const ordersService = { getStatuses, getStatusColor, getDisplayStatus };
export default ordersService;
